import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import * as actions from './actions'
import { InitialState, VideoItemType } from './types'
import usePrevious from '../../hooks/usePrevious'
import { BlockType, LinkItemType } from '../LessonPage/types'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'

// Blocks
import AdminLinksBlock from '../../components/AdminLinksBlock'
import AdminFilesBlock from '../../components/AdminFilesBlock'
import AdminVideosBlock from '../../components/AdminVideosBlock'
import AdminGalleryBlock from '../../components/AdminGalleryBlock'

function BlockContainer({
  block,
  links,
  videos,
}: {
  block: BlockType
  links: LinkItemType[]
  videos: VideoItemType[]
}): JSX.Element {
  switch (block.type) {
    case 'links':
      return <AdminLinksBlock block={block} links={links} />
    case 'files':
      return <AdminFilesBlock block={block} />
    case 'videos':
      return <AdminVideosBlock block={block} videos={videos} />
    case 'gallery':
      return <AdminGalleryBlock block={block} />
    default:
      return <p>Не удалось найти такой тип блока</p>
  }
}

export default () => {
  const { bid } = useParams<{ bid: string }>()
  const dispatch = useDispatch()

  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  const isMounted = useRef<boolean>(false)
  const isFetchedAdditionalData = useRef<boolean>(false)

  const { block, videos, links, processIsFetchingBlock, error } = useSelector(
    (state: { adminBlockEdit: InitialState }) => state.adminBlockEdit
  )

  const prevProcessIsFetchingBlock = usePrevious(processIsFetchingBlock)

  useEffect(() => {
    if (!processIsFetchingBlock && prevProcessIsFetchingBlock) {
      setIsLoaded(true)
    }
  }, [processIsFetchingBlock])

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchBlock(bid))
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (!isFetchedAdditionalData.current && block) {
      switch (block.type) {
        case 'links':
          dispatch(actions.fetchLinks())
          break
        case 'videos':
          dispatch(actions.fetchVideos())
      }
      isFetchedAdditionalData.current = true
    }
  }, [block])

  return (
    <>
      <Header />
      <div className={'container'}>
        <h2>Панель администрирования - Редактирование блока</h2>
        {(!isMounted.current || processIsFetchingBlock) && !isLoaded ? (
          <p>Загрузка блока...</p>
        ) : block ? (
          <BlockContainer block={block} links={links} videos={videos} />
        ) : (
          <p>Блок не был загружен!</p>
        )}
        {error ? <p style={{ color: 'red' }}>{error}</p> : null}
      </div>
      <Footer />
    </>
  )
}
